<template>
    <div class="app">
        <ResponsiveMenu :class="[visibleResponsiveMenu == true ? 'visible-menu' : 'hidden-menu']"></ResponsiveMenu>
        <AppHeader fixed>
            <div v-if="displayMenu">
                <button @click="showResponsiveMenu()" class="btn sidebar-minimizer">
                    <i class="fa fa-"></i>
                </button>
                <router-link to="/dashboard" :class="['navbar-brand']">
                    <img src="../assets/img/lightlogo.svg" class="light-version" alt="">
                    <img src="../assets/img/darklogo.svg" class="dark-version" alt="">
                </router-link>
                <AvailableFundWidget v-if="availableFundsWidgetAccess && typeAccount != 'OFFLINE_BILLING'"></AvailableFundWidget>
            </div>
            <div v-else>
                <div class="navbar-brand no-menu-navbar-brand">
                    <img src="../assets/img/lightlogo.svg" class="light-version" alt="">
                    <img src="../assets/img/darklogo.svg" class="dark-version" alt="">
                </div>
            </div>
            <div class="logout-dropdown-container">
                <LogoutDropdown :disable="displayMenu == false"></LogoutDropdown>
            </div>
            <!--<AsideToggler class="d-lg-none" mobile />-->
        </AppHeader>
        <div class="app-body">
            <AppSidebar v-if="displayMenu" fixed>
                <SidebarHeader/>
                <SidebarForm/>
                <SidebarNav :navItems="nav"></SidebarNav>
                <SidebarFooter/>
            </AppSidebar>
            <main :class="['main', displayMenu ? '' : 'no-menu']">
                <ftsbreadcrumbs v-if="displayMenu" :route="list"></ftsbreadcrumbs>
                <div :class="['container-fluid', allowActions ? '' : 'block-actions']">
                    <router-view></router-view>
                </div>
            </main>
        </div>
        <b-modal hide-footer hide-header id="accept-terms" ref="accept-terms" size="lg" class="accept-terms" centered no-close-on-esc no-close-on-backdrop>
            <div class="terms-and-conditions-topbar">
                <div class="logo-container">
                    <img src="../assets/img/lightlogo.svg" class="light-version" alt="SimonIoT Logo">
                    <img src="../assets/img/darklogo.svg" class="dark-version" alt="SimonIoT Logo">
                </div>
                <h3>Terms and conditions</h3>
            </div>
            <div class="terms-and-conditions-text" v-html="termsContent" @scroll="checkScroll"></div>
            <div :class="['accept-bar', termsRead ? 'buttons-visible' : 'text-visible']">
                <button class="btn btn-success accept" @click="acceptTerms()" :disabled="!termsRead">Accept Terms and Conditions</button>
                <p>Scroll down to accept terms and conditions</p>
            </div>
        </b-modal>

        <MaintenanceAlert v-if="maintenance" @maintenanceAccepted="hideMaintenanceAlert()"></MaintenanceAlert>
        <b-modal v-if="annoucements.length > 0" hide-header hide-footer ref="announcements" id="announcements" :size="annoucements.length > 1 ? 'lg' : 'md'" centered no-close-on-esc no-close-on-backdrop>
            <div v-if="annoucements.length == 1" class="single-announcement">
                <img class="announcement-icon" src="img/announcement-icon.svg" alt="">
                <h3>{{annoucements[annoucementDisplayed].title}}</h3>
                <strong v-if="annoucements[annoucementDisplayed].startDateInfo || annoucements[annoucementDisplayed].endDateInfo">{{annoucements[annoucementDisplayed].startDateInfo}} <span v-if="annoucements[annoucementDisplayed].startDateInfo && annoucements[annoucementDisplayed].endDateInfo"> - </span> {{annoucements[annoucementDisplayed].endDateInfo}}</strong>
                <img class="announcement-img" :src="'img/' + annoucements[annoucementDisplayed].img"/>
                <p v-html="annoucements[annoucementDisplayed].htmlContent"></p>
                <button class="btn btn-primary" @click="acknowledgeAnnouncements()">Acknowledge</button>
            </div>
            <div v-else class="announcements-list">
                <div class="announcements-list-header">
                    <div class="left-side">
                        <img class="announcement-icon" src="img/announcement-icon.svg" alt="">
                        <h1>Announcements</h1>
                    </div>
                    <strong class="counter">{{annoucementDisplayed + 1}}/{{annoucements.length}}</strong>
                </div>
                <h3 class="hello-user">Hello {{$cookies.get('firstName')}} {{$cookies.get('lastName')}}!</h3>
                <p class="announcements-list-info">New and exciting things have happened since your lost login! <br/>We prepared a brief summary for you.</p>
                <div class="annoucement">
                    <strong class="counter-mobile">{{annoucementDisplayed + 1}}/{{annoucements.length}}</strong>
                    <div class="left-side">
                        <h3>{{annoucements[annoucementDisplayed].title}}</h3>
                        <strong v-if="annoucements[annoucementDisplayed].startDateInfo || annoucements[annoucementDisplayed].endDateInfo">{{annoucements[annoucementDisplayed].startDateInfo}} <span v-if="annoucements[annoucementDisplayed].startDateInfo && annoucements[annoucementDisplayed].endDateInfo"> - </span> {{annoucements[annoucementDisplayed].endDateInfo}}</strong>
                        <p v-html="annoucements[annoucementDisplayed].htmlContent"></p>
                    </div>
                    <div class="right-side">
                        <img :src="'img/' + annoucements[annoucementDisplayed].img"/>
                    </div>
                </div>
                <div class="slider-control">
                    <button @click="previousAnnouncement()" class="next-prev-btn previous">Previous</button>
                    <button v-for="(item, i) of annoucements" :class="['annoucement-btn', annoucementDisplayed == i ? 'selected' : '']" @click="switchAnnouncement(i)"></button>
                    <button @click="nextAnnouncement()" class="next-prev-btn next">Next</button>
                </div>
                <button class="btn btn-primary" @click="acknowledgeAnnouncements()">Acknowledge all</button>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="invitations" id="invitations" centered no-close-on-esc no-close-on-backdrop>
            <div v-if="invitations.length == 1" class="single-invitation">
                <img src="../assets/img/user-blue.svg" alt="">
                <h3>Invitation</h3>
                <p class="invitation-content">You have been invited by <strong v-if="invitations[0]">{{invitations[0].invitingUserName}}</strong> to be part of <strong v-if="invitations[0]">{{invitations[0].invitedCompanyName}}</strong>!</p>
                <p class="invitation-decide-later-info">If you want to decide later, you will find this message in your inbox.</p>
                <p class="invitation-info">Please decline if the invitation was not meant for You.</p>
                <div class="control-bar">
                    <div class="left-side">
                        <button class="btn btn-light" @click="hideInvitations(invitations[0])">Decide Later</button>
                    </div>
                    <div class="right-side">
                        <button class="btn btn-danger" @click="declineInvitation(invitations[0])">Decline</button>
                        <button class="btn btn-success" @click="acceptInvitation(invitations[0])">Accept</button>
                    </div>
                </div>
            </div>
            <div v-else-if="invitations.length > 1" class="multiple-invitations">
                <div class="invitations-header">
                    <div class="left-side">
                        <h3 class="hello-user">Hello {{$cookies.get('firstName')}} {{$cookies.get('lastName')}}!</h3>
                        <p class="invitations-list-info">There are {{invitations.length}} invitations awaiting. <br/>Please select if you want to accept, decline or to decide later on each one of them and confirm your selection.</p>
                    </div>
                    <h3 class="counter">{{invitationDisplayed + 1}}/{{invitations.length}}</h3>
                </div>
                <div class="invitations-list">
                    <div class="invitation">
                        <img src="../assets/img/user-blue.svg" alt="">
                        <h3>Invitation</h3>
                        <p class="invitation-content">You have been invited by <strong v-if="invitations[invitationDisplayed]">{{invitations[invitationDisplayed].invitingUserName}}</strong> to be part of <strong v-if="invitations[invitationDisplayed]">{{invitations[invitationDisplayed].invitedCompanyName}}</strong>!</p>
                        <p class="invitation-decide-later-info">If you want to decide later, you will find this message in your inbox.</p>
                        <p class="invitation-info">Please decline if the invitation was not meant for You.</p>
                        <div class="control-bar">
                            <div class="left-side">
                                <button class="btn btn-light" @click="nextInvitation()"><i class="fa fa-clock-o"></i><span>Decide Later</span></button>
                            </div>
                            <div class="right-side">
                                <button class="btn btn-danger" @click="declineInvitation(invitations[invitationDisplayed])"><i class="fa fa-times"></i><span>Decline</span></button>
                                <button class="btn btn-primary" @click="acceptInvitation(invitations[invitationDisplayed])"><i class="fa fa-check"></i><span>Accept</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue'
    import nav from "@/_nav";
    import keycloak from "../main";
    import {
        Header as AppHeader,
        Sidebar as AppSidebar,
        SidebarForm,
        SidebarHeader,
        SidebarMinimizer,
        SidebarNav,
        Aside as AppAside,
        AsideToggler,
        Footer as TheFooter,
        Breadcrumb
    } from "@coreui/vue";
    import Axios from 'axios'
    import ResponsiveMenu from './ResponsiveMenu';

    import DefaultHeaderDropdown from "./DefaultHeaderDropdown";
    import DefaultHeaderDropdownNotif from "./DefaultHeaderDropdownNotif";
    import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
    import DefaultHeaderDropdownMssgs from "./DefaultHeaderDropdownMssgs";
    import DefaultHeaderDropdownTasks from "./DefaultHeaderDropdownTasks";

    import AvailableFundWidget from "./../views/payments/AvailableFunds";
    import UserInHeader from "./../views/users/UserInHeader";

    import SidebarFooter from "./../views/sidebar/Footer";

    import ftsbreadcrumbs from '../shared/ftsbreadcrumbs';

    import VueSession from "vue-session";
    import VueCookies from 'vue-cookies'

    import globalStore from '../variables';
    import MaintenanceAlert from "../views/maintenance/MaintenanceAlert";
    import LogoutDropdown from "@/views/LogoutDropdown";


    Vue.use(VueSession);
    Vue.use(VueCookies);
    Vue.$cookies.config('7d','','',true)

    export default {
        name: "DefaultContainer",
        components: {
            LogoutDropdown,
            MaintenanceAlert,
            AsideToggler,
            AppHeader,
            AppSidebar,
            AppAside,
            TheFooter,
            Breadcrumb,
            DefaultHeaderDropdown,
            DefaultHeaderDropdownMssgs,
            DefaultHeaderDropdownNotif,
            DefaultHeaderDropdownTasks,
            DefaultHeaderDropdownAccnt,
            SidebarForm,
            SidebarFooter,
            SidebarHeader,
            SidebarNav,
            SidebarMinimizer,
            AvailableFundWidget,
            UserInHeader,
            ftsbreadcrumbs,
            ResponsiveMenu
        },
        data() {
            return {
                nav: [],
                alertsCount: 0,
                typeAccount: '',
                userLevelId: '',
                newestTermsId: null,
                acceptedTermsId: null,
                termsContent: '',
                termsRead: false,
                visibleResponsiveMenu: false,
                maintenance: false,
                annoucements: [],
                annoucementDisplayed: 0,
                invitations: [],
                invitationsReady: false,
                invitationDisplayed: 0,
                currentInvitationStatus: null,
                displayMenu: true,
                performActionPermissions: [
                    {
                        name: 'Dashboard',
                        actionPermissions: ['DASHBOARD','SUPER_ADMIN_PANEL']
                    },
                    {
                        name: 'SIM Activation',
                        actionPermissions: ['ACTIVATION_COLD_STOCK_WRITE','COLD_STOCK_MANAGEMENT',' ORDER_MANAGEMENT','PERFORM_ACTIONS_ON_COMPANY']
                    },
                    {
                        name: 'SIM Management',
                        actionPermissions: null
                    },
                    {
                        name: 'SIM details',
                        actionPermissions: ['SIM_MANAGEMENT_WRITE','PERFORM_ACTIONS_ON_COMPANY']
                    },
                    {
                        name: 'ColdStock',
                        actionPermissions: ['ACTIVATION_COLD_STOCK_WRITE','COLD_STOCK_MANAGEMENT',' ORDER_MANAGEMENT','PERFORM_ACTIONS_ON_COMPANY']
                    },
                    {
                        name: 'Bulk Select Carrier',
                        actionPermissions: null
                    },
                    {
                        name: 'Bulk Operations',
                        actionPermissions: ['SIM_MANAGEMENT_WRITE','PERFORM_ACTIONS_ON_COMPANY']
                    },
                    {
                        name: 'Transaction Logs',
                        actionPermissions: null
                    },
                    {
                        name: 'TransactionDetails',
                        actionPermissions: ['TRANSACTIONS_WRITE','PERFORM_ACTIONS_ON_COMPANY']
                    },
                    {
                        name: 'OrderSims',
                        actionPermissions: ['ORDERS_WRITE','ORDER_MANAGEMENT','ORDERS_CREATE','SUPER_ADMIN_PANEL']
                    },
                    {
                        name: 'OrderDetails',
                        actionPermissions: 'ORDERS_CREATE'
                    },
                    {
                        name: 'OrderHistory',
                        actionPermissions: null
                    },
                    {
                        name: 'Reports',
                        actionPermissions: ['REPORTS_WRITE','SUPER_ADMIN_PANEL']
                    },
                    {
                        name: 'Alerts',
                        actionPermissions: ['ALERTS_WRITE','PERFORM_ACTIONS_ON_COMPANY']
                    },
                    {
                        name: 'Balance & Pools',
                        actionPermissions: null
                    },
                    {
                        name: 'BillingsTransactions',
                        actionPermissions: null
                    },
                    {
                        name: 'Payment History',
                        actionPermissions: null
                    },
                    {
                        name: 'Company',
                        actionPermissions: ['COMPANY_SETTINGS_WRITE','PERFORM_ACTIONS_ON_COMPANY']
                    },
                    {
                        name: 'Users',
                        actionPermissions: ['USERS_WRITE','PERFORM_ACTIONS_ON_COMPANY']
                    },
                    {
                        name: 'Payment Method',
                        actionPermissions: ['BILLING_WRITE','PERFORM_ACTIONS_ON_COMPANY']
                    },
                    {
                        name: 'Plans',
                        actionPermissions: ['PLANS_WRITE','PERFORM_ACTIONS_ON_COMPANY']
                    },
                    {
                        name: 'Tags',
                        actionPermissions: ['CUSTOM_FIELDS_AND_TAGS_WRITE','PERFORM_ACTIONS_ON_COMPANY']
                    },
                    {
                        name: 'CustomFields',
                        actionPermissions: ['CUSTOM_FIELDS_AND_TAGS_WRITE','PERFORM_ACTIONS_ON_COMPANY']
                    },
                    {
                        name: 'Support',
                        actionPermissions: null
                    }
                ],
                allowActions: false,
                permissions: [],
                availableFundsWidgetAccess: false
            };
        },
        methods: {
            showResponsiveMenu() {
                if ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <= 991) {
                    this.visibleResponsiveMenu = (this.visibleResponsiveMenu == false) ? true : false;
                } else {
                    document.body.classList.toggle('sidebar-minimized');
                    document.body.classList.toggle('brand-minimized');
                }
            },
            getAlertsCount() {
                Axios.get(globalStore.data.restApiUrl + '/usage-alerts/counts')
                    .then(response => {
                        this.alertsCount = response.data.unseenAlertsTriggeredInCurrentBillingPeriod;
                        if (this.alertsCount) {
                            let alertsBar = document.querySelector('.sidebarnav-alerts a');
                            let alertsCount = document.createElement("span")
                            alertsCount.classList.add("alerts-count")
                            alertsCount.innerHTML = this.alertsCount;
                            alertsBar.appendChild(alertsCount);
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'Something was wrong during getting data of alerts. Please, contact support.',
                            duration: 5000,
                        });
                        console.log(error);
                    })
            },
            checkAccess() {
                if (this.$session.get('companyId') == undefined && this.$router.currentRoute.name != 'UserProfile' && (this.$session.get('userLevelId') == 4 || this.$session.get('userLevelId') == 5 || this.$session.get('userLevelId') == 6 || this.$session.get('userLevelId') == 8 || this.$session.get('userLevelId') == 10)) {
                    this.$router.push('/admin')
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Access denied.',
                        text: 'You are trying to get access to a component without being logged as company. Please, login to company panel through company details screen.',
                        duration: 10000,
                    });
                }
            },
            checkTerms() {
                this.acceptedTermsId = this.$cookies.get('acceptedAgreementId');
                if (this.acceptedTermsId != 'false') {
                    Axios.get(globalStore.data.restApiUrl + '/terms-and-conditions/most-recent-id')
                        .then(response => {
                            this.newestTermsId = response.data
                            if (this.newestTermsId != this.acceptedTermsId) {
                                this.getTermsContent(false);
                                this.$refs['accept-terms'].show();
                            }
                        })
                } else {
                    this.getTermsContent(false);
                    this.$refs['accept-terms'].show();
                }

            },
            acceptTerms() {
                let clientIp = '8.8.8.8';

                let dataToSend = {
                    email: this.$cookies.get('userEmail'),
                    firstName: this.$cookies.get('firstName'),
                    lastName: this.$cookies.get('lastName'),
                    clientIp: clientIp
                }

                Axios.post(globalStore.data.restApiUrl + '/terms-and-conditions', dataToSend)
                    .then(response => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Your agreement has been saved',
                            text: 'Thank you for accept our terms and conditions.',
                            duration: 5000,
                        });
                        this.$cookies.set('acceptedAgreementId', response.data);
                        this.$refs['accept-terms'].hide();
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Your agreement has not been saved',
                        text: 'Something went wrong during saving your agreement. Please, try again.',
                        duration: 5000,
                    });
                    console.log(error)
                })

            },
            getTermsContent(show) {
                Axios.get(globalStore.data.restApiUrl + '/terms-and-conditions/most-recent')
                    .then(response => {
                        this.termsContent = response.data.content;
                        if (show == true) {
                            this.$refs['terms'].show();
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            checkScroll(ev) {
                let maxScroll = ev.target.scrollHeight - ev.target.clientHeight;
                let currentScrollPosition = ev.target.scrollTop;
                if (currentScrollPosition >= (maxScroll - 5)) {
                    this.termsRead = true;
                }
            },
            filterNav(navItemName) {
                for (let i = 0; i < this.nav.length; i++) {
                    if (this.nav[i].name == navItemName) {
                        this.nav.splice(i, 1);
                    } else {
                        if (this.nav[i].children) {
                            for(let j = 0; j < this.nav[i].children.length; j++) {
                                if (this.nav[i].children[j].name == navItemName) {
                                    this.nav[i].children.splice(j, 1);
                                }
                            }
                        }
                    }
                }
            },
            hideMaintenanceAlert() {
                this.maintenance = false
                this.$cookies.set('maintenanceWarn', 'displayed','30d')
            },
            switchAnnouncement(index) {
                this.annoucementDisplayed = index
            },
            previousAnnouncement() {
                if (this.annoucementDisplayed > 0) {
                    this.annoucementDisplayed--
                }
            },
            nextAnnouncement() {
                if (this.annoucementDisplayed + 1 != this.annoucements.length) {
                    this.annoucementDisplayed++
                }
            },
            nextInvitation() {
                if (this.invitationDisplayed + 1 != this.invitations.length) {
                    this.invitationDisplayed++
                    this.currentInvitationStatus = null
                } else {
                    this.hideInvitations()
                }
            },
            acknowledgeAnnouncements() {
                let ids = []
                for (let item of this.annoucements) {
                    ids.push(item.announcementId)
                }
                Axios.post(globalStore.data.restApiUrl + '/announcement/new-display', ids)
                    .then(response => {
                        this.annoucements = []
                        this.$refs['announcements'].hide();
                        if (this.invitationsReady && this.invitations.length != 0) {
                            this.showInvitations()
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            checkForAnnouncements() {
                Axios.get(globalStore.data.restApiUrl + '/announcement/not-displayed')
                    .then(response => {
                        this.annoucements = response.data
                        if (this.annoucements.length > 0) {
                            for (let item of this.annoucements) {
                                if (item.type.serverName == 'MAINTENANCE') {
                                    item.img = 'maintenance-img.svg'
                                } else if (item.type.serverName == 'WORKING_ON_ISSUE') {
                                    item.img = 'working-on-issue-img.svg'
                                } else if (item.type.serverName == 'RELEASE_NOTES') {
                                    item.img = 'new-features-img.svg'
                                } else if (item.type.serverName == 'IMPORTANT_INFORMATION') {
                                    item.img = 'important-information-img.svg'
                                } else if (item.type.serverName == 'COMPONENT_ISSUE') {
                                    item.img = 'component-offline-img.svg'
                                }
                            }
                            setTimeout(() => {
                                this.$refs['announcements'].show();
                            },500)
                        } else  {
                            if (this.invitationsReady && this.invitations.length > 0) {
                                this.showInvitations()
                            }
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Announcements error',
                            text: 'Something went wrong during getting data of announcements. Please, contact support.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            checkForInvitations() {
                Axios.get(globalStore.data.restApiUrl + '/associates/users/invitation/' + this.$cookies.get('userId'))
                    .then(response => {
                        this.invitations = response.data
                        this.invitationsReady = true
                        if (!this.$refs['announcements'] && this.invitations.length) {
                            console.log(this.invitations)
                            this.showInvitations()
                        }
                    })
                this.$cookies.remove('hasPendingInvitation')
            },
            showInvitations() {
                this.$refs['invitations'].show();
            },
            hideInvitations() {
                this.$refs['invitations'].hide();
            },
            acceptInvitation(invitation) {
                Axios.post(globalStore.data.restApiUrl + '/associates/users/confirm', [invitation.invitationCode])
                    .then(response => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Invitations accepted',
                            text: 'Selected invitations has been accepted succesfully.',
                            duration: 5000,
                        });
                        this.nextInvitation()
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Invitations accept error',
                            text: 'Something went wrong during accepting selected invitations. Please, contact support.',
                            duration: 5000,
                        });
                    })
            },
            declineInvitation(invitation) {
                Axios.post(globalStore.data.restApiUrl + '/associates/users/reject', [invitation.invitationCode])
                    .then(response => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Invitations accepted',
                            text: 'Selected invitations has been rejected succesfully.',
                            duration: 5000,
                        });
                        this.nextInvitation()
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Invitations accept error',
                            text: 'Something went wrong during rejecting selected invitations. Please, contact support.',
                            duration: 5000,
                        });
                    })
            },
            checkPermission(permission) {
                let ret = false
                if (permission.permission == null) {
                    ret = true
                } else if (typeof permission.permission == 'string') {
                    if (this.permissions.indexOf(permission.permission) > -1) {
                        ret = true
                    }
                } else if (typeof permission.permission == 'object') {
                    let isAll = 0
                    for (let item of permission.permission) {
                        if (this.permissions.indexOf(item) > -1) {
                            isAll++
                        }
                    }
                    if (isAll) {
                        ret = true
                    }
                }
                return ret
            },
            checkActionPermissions() {
                this.allowActions = false
                for(let item of this.performActionPermissions) {
                    if (this.$route.name == item.name) {
                        if (item.actionPermissions == null) {
                            this.allowActions = true
                            return false
                        } else if (typeof item.actionPermissions == 'string') {
                            if (this.permissions.indexOf(item.actionPermissions) > -1) {
                                this.allowActions = true
                            }
                        } else if (typeof item.actionPermissions == 'object') {
                            for (let arrItem of item.actionPermissions) {
                                if (this.permissions.indexOf(arrItem) > -1) {
                                    this.allowActions = true
                                    return false
                                }
                            }
                        } else {
                            this.allowActions = false
                        }
                        return false
                    }
                }
            },
            setMenuItems() {
                this.nav = [];
                this.changeOrderUrl()
                if ((keycloak.token || this.$session.get('token') || this.$cookies.get('token')) && this.$cookies.get('isSA') == 'false') {
                    this.permissions = this.$cookies.get('permissions').split(',')
                    for (let item of nav.items) {
                        if (this.checkPermission(item)) {
                            if (item.children) {
                                let childrenTemplate = []
                                for (let childItem of item.children) {
                                    if (this.checkPermission(childItem)) {
                                        childrenTemplate.push(childItem)
                                    }
                                }
                                let tempItem = {
                                    name: item.name,
                                    url: item.url,
                                    icon: item.icon,
                                    permission: item.permission,
                                }
                                tempItem.children = childrenTemplate
                                if (tempItem.name == 'Order') {
                                    if (this.typeAccount != 'OFFLINE_BILLING') {
                                        this.nav.push(tempItem)
                                    }
                                } else {
                                    this.nav.push(tempItem)
                                }
                            } else {
                                this.nav.push(item)
                            }
                        }
                    }

                    if ((this.userLevelId == 1 || this.userLevelId == 9) && ((this.permissions.indexOf('AFFILIATE_PROGRAM_READ') > -1) || this.permissions.indexOf('SUPER_ADMIN_PANEL') > -1)) {
                        Axios.get(globalStore.data.restApiUrl + '/affiliate/customer/is-approved?companyId=' + this.$cookies.get('companyId'))
                            .then(response => {
                                if (response.data == true) {
                                    let index = null
                                    let billingIndex = false
                                    let settingsIndex = false
                                    for (let i = 0; i < this.nav.length; i++) {
                                        if (this.nav[i].name == 'Billing') {
                                            billingIndex = i
                                        }
                                        if (this.nav[i].name == 'Settings') {
                                            settingsIndex = i
                                        }
                                    }
                                    if (billingIndex) {
                                        index = billingIndex
                                    } else if (settingsIndex) {
                                        index = settingsIndex
                                    } else {
                                        index = this.nav.length - 1
                                    }
                                    this.nav.splice(index, 0, {
                                        name: 'Affiliate Program',
                                        url: '/affiliate-program',
                                        icon: 'fa fa-pie-chart'
                                    });
                                }
                            })
                    }
                    this.checkAvailableFundsWidgetAccess()
                } else if ((keycloak.token || this.$session.get('token') || this.$cookies.get('token')) && this.$session.get('isSA')) {
                    this.permissions = this.$session.get('saPermissions')
                    for (let item of nav.items) {
                        if (this.checkPermission(item)) {
                            if (item.children) {
                                let childrenTemplate = []
                                for (let childItem of item.children) {
                                    if (this.checkPermission(childItem.permission)) {
                                        childrenTemplate.push(childItem)
                                    }
                                }
                                let tempItem = {
                                    name: item.name,
                                    url: item.url,
                                    icon: item.icon,
                                    permission: item.permission,
                                }
                                tempItem.children = childrenTemplate
                                if (tempItem.name == 'Order') {
                                    if (this.typeAccount != 'OFFLINE_BILLING') {
                                        this.nav.push(tempItem)
                                    }
                                } else {
                                    this.nav.push(tempItem)
                                }
                            } else {
                                this.nav.push(item)
                            }
                        }
                    }
                    this.checkAvailableFundsWidgetAccess()
                } else {
                    this.$router.push('/login')
                }
            },
            checkAvailableFundsWidgetAccess() {
                if (this.permissions.indexOf('BILLING_READ') > -1 || this.permissions.indexOf('BILLING_WRITE') > -1 || this.permissions.indexOf('SUPER_ADMIN_PANEL') > -1) {
                    this.availableFundsWidgetAccess = true
                } else {
                    this.availableFundsWidgetAccess = false
                }
            },
            listenerOnRwdMenu() {
                document.querySelectorAll("a.nav-link").forEach((item) => {
                    item.addEventListener('click', (event) => {
                        this.visibleResponsiveMenu = false;
                    })
                })
                document.querySelector(".user-thumbnail-wrapper").addEventListener('click', (event => {
                    this.visibleResponsiveMenu = false;
                }))

                document.querySelector(".user-data-wrapper").addEventListener('click', (event => {
                    this.visibleResponsiveMenu = false;
                }))
            },
            displayMenuCheck() {
                if (this.$route.name != 'AdditionalInfo') {
                    this.displayMenu = true
                } else {
                    this.displayMenu = false
                }
            },
            changeOrderUrl() {
                let typeAccount = this.$session.get('token') ? this.$session.get('typeAccount') : this.$cookies.get('typeAccount')
                if (typeAccount == 'HYBRID_TERMS') {
                    for (let i in nav.items) {
                        if (nav.items[i].name == 'Order') {
                            nav.items.splice(i,1)
                            break;
                        }
                    }
                } else if (this.$cookies.get('defaultLogin') == 'false') {
                    for (let item of nav.items) {
                        if (item.name == 'Order') {
                            item.url = globalStore.data.koreShopUrl
                            item.class = 'new-tab'
                            delete item.children
                            break;
                        }
                    }
                }
            },
            addTargetBlank() {
                for(let item of document.querySelectorAll('.new-tab a')) {
                    item.setAttribute('target', '_blank')
                }
            }

        },
        created() {
            let now = new Date()
            if (globalStore.data.maintenance && globalStore.data.maintenance.from > now && this.$cookies.get('maintenanceWarn') != 'displayed') {
                this.maintenance = true
            }
        },
        mounted() {
            this.userLevelId = Number(this.$cookies.get('userLevelId')) ? Number(this.$cookies.get('userLevelId')) : this.$session.get('userLevelId')
            this.checkAccess();
            this.getAlertsCount();
            this.displayMenuCheck()
            this.changeOrderUrl()

            if (this.$session.get('typeAccount') != '' && this.$session.get('typeAccount') != undefined) {
                this.typeAccount = this.$session.get('typeAccount')
            } else {
                this.typeAccount = this.$cookies.get('typeAccount')
            }

            this.setMenuItems()

            if (this.$cookies.get('userLevelId') == 1 || this.$cookies.get('userLevelId') == 2 || this.$cookies.get('userLevelId') == 3) {
                this.checkTerms();
            }

            if (!this.$session.get('token')) {
                this.checkForAnnouncements();
                if (this.$cookies.get('hasPendingInvitation') == "true") {
                    this.checkForInvitations()
                }
            }
            if ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <= 991) {
                let checkMenuIsReady = setInterval(() => {
                    if (document.querySelector("a.nav-link")) {
                        this.listenerOnRwdMenu();
                        clearInterval(checkMenuIsReady);
                    }
                }, 500);
            }

            this.checkActionPermissions()
            setTimeout(() => {this.addTargetBlank()}, 100)
        },
        watch: {
            '$route' () {
                this.checkActionPermissions()
                this.displayMenuCheck()
            }
        },
        computed: {
            name() {
                return this.$route.name;
            },
            list() {
                return this.$route.matched.filter(
                    route => route.name || route.meta.label
                );
            }
        }
        // watch: {
        //     '$route'(to, from) {
        //         this.visibleResponsiveMenu = false;
        //         if (to.meta.permission.indexOf(this.userLevelId) == -1) {
        //             if (this.$cookies.get('token')) {
        //                 this.$router.push('/dashboard')
        //             } else {
        //                 this.$router.push('/admin/companies')
        //             }
        //
        //             this.$notify({
        //                 type: 'error',
        //                 group: 'notification',
        //                 title: 'Access denied',
        //                 text: 'Your role has no permission to access this screen.',
        //                 duration: 5000,
        //             });
        //         }
        //     }
        // }
    };
</script>
<style lang="scss">
    .no-menu {
        margin-left: 0 !important;
    }
    @media screen and (max-width: 450px) {
        .logout-dropdown-container {
            flex-grow: 1;
        }
    }
    #accept-terms___BV_modal_content_,
    #terms___BV_modal_content_ {
        background-color: #ffffff;
        color: #000000;

        .terms-and-conditions-topbar {
            display: flex;
            flex-direction: column;
            margin-bottom: 8px;

            .logo-container {
                display: flex;
                justify-content: center;
                margin: 20px 0;
                .dark-version {
                    display: none;
                }
                .light-version {
                    display: initial;
                }
            }

            h3 {
                font-size: 20px;
            }

            i {
                cursor: pointer;
                &:before {
                    color: #000000;
                }
            }
        }

        .terms-and-conditions-text {
            width: 100%;
            max-height: calc(100vh - 247px);
            overflow: scroll;
            padding-right: 12px;
            h3 {
                font-size: 16px;
                font-weight: 700;
            }
        }

        .terms-and-conditions-text iframe {
            width: 100%;
            height: 70vh;
        }

        .accept-bar {
            display: flex;
            p {
                color: #0088FF;
            }
            &.buttons-visible {
                justify-content: flex-end;
                p {
                    display: none;
                }
                button {
                    display: initial;
                }
                .accept {
                    margin-left: 20px;
                }
            }

            &.text-visible {
                justify-content: center;
                button {
                    display: none;
                }
                p {
                    display: initial;
                }
            }
        }
    }

    #announcements___BV_modal_content_ {
        margin-top: 60px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        border-radius: 20px;
    }

    #invitations___BV_modal_body_ {
        padding: 0;
        .single-invitation,
        .multiple-invitations .invitations-list .invitation {
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
                margin: 20px 0;
            }

            h3 {
                margin: 0 0 12px;
                font-size: 14px;
                font-weight: 700;
            }

            .invitation-content {
                font-size: 14px;
                line-height: 18px;
                text-align: center;
                margin: 0 20px 16px;
            }
            .invitation-decide-later-info {
                margin: 0 0 44px;
                font-size: 13px;
                line-height: 18px;
            }
            .invitation-info {
                margin: 0 0 10px;
                color: #515B65;
                font-size: 13px;
                line-height: 18px;
            }

            .control-bar {
                width: 100%;
                display: flex;
                justify-content: space-between;
                padding-top: 0;
                border: none;
                .left-side {
                    .btn {
                        width: 120px;
                        text-align: center;
                        i.fa {
                            display: none;
                            margin: 0;
                        }
                        &.icon-visible {
                            i.fa {
                                display: initial;
                            }
                            span {
                                display: none;
                            }
                        }
                    }
                }
                .right-side {
                    .btn {
                        width: 84px;
                        text-align: center;
                        i.fa {
                            display: none;
                            margin: 0;
                        }
                        &.icon-visible {
                            i.fa {
                                display: initial;
                            }
                            span {
                                display: none;
                            }
                        }
                        &:first-child {
                            margin-right: 10px;
                        }
                    }
                }
            }
        }

        .multiple-invitations {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 30px;
            .invitations-header {
                display: flex;
                justify-content: space-between;
                .counter {
                    margin: 0;
                    font-size: 15px;
                }
            }
            .hello-user {
                margin: 0 0 16px;
                font-size: 15px;
                font-weight: 700;
            }
            .invitations-list {
                .invitation {
                    width: 100%;
                    padding: 20px 25px;
                    border: 1px solid #C9CFD4;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    .control-bar {
                        padding: 0;
                    }
                }
            }

            .slider-control {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                margin: 24px 0;
                .next-prev-btn {
                    border: 0;
                    background-color: #fff;
                    color: #929292;
                    outline: none;
                    &.previous {
                        margin-right: 20px;
                    }
                    &.next {
                        margin-left: 20px;
                    }
                }
                .invitation-btn {
                    width: 8px;
                    height: 8px;
                    padding: 0;
                    margin-right: 6px;
                    background-color: #e5e5e5;
                    border: 0;
                    -webkit-border-radius: 4px;
                    -moz-border-radius: 4px;
                    border-radius: 4px;
                    outline: none;

                    &.selected {
                        background-color: #0088FF;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
            .control-bar {
                display: flex;
                justify-content: space-between;
                width: 100%;
                border: none;
                padding: 0;
                .left-side {
                    .btn {
                        font-weight: 700;
                        &:first-child {
                            margin-right: 10px;
                        }
                    }
                }
                .right-side {
                    .btn {
                        font-weight: 700;
                    }
                }
            }
        }
    }

    #announcements___BV_modal_content_ {
        border: 0;
    }

    #announcements___BV_modal_body_ {
        padding: 20px 25px;
        .single-announcement {
            display: flex;
            flex-direction: column;
            align-items: center;
            .announcement-icon {
                margin-bottom: 12px;
            }
            h3 {
                margin: 0 0 16px;
                font-size: 14px;
                font-weight: 700;
            }
            strong {
                margin: 0 0 20px;
                font-size: 14px;
            }
            .announcement-img {
                height: 150px;
                width: auto;
                margin: 0 0 20px;
            }
            p {
                width: 100%;
            }
        }
        .announcements-list {
            .hello-user {
                font-weight: 700;
            }
            .announcements-list-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 0 0 20px;
                .left-side {
                    display: flex;
                    align-items: center;
                    img {
                        margin-right: 12px;
                    }

                    h1 {
                        margin: 0;
                        font-size: 15px;
                    }
                }
            }
            h3 {
                font-size: 14px;
            }
            .announcements-list-info {
                margin-bottom: 30px;
            }
            .annoucement {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border: 1px solid #C9CFD4;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                .counter-mobile {
                    display: none;
                }
                .left-side {
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    padding: 34px;
                    h3 {
                        margin: 0 0 6px;
                        font-size: 14px;
                        font-weight: 700;
                    }
                    strong {
                        margin: 0 0 20px;
                        font-size: 14px;
                    }
                }
                .right-side {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-width: 35%;
                    padding: 30px;
                }
            }
            .slider-control {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                margin: 24px 0;
                .next-prev-btn {
                    border: 0;
                    background-color: #fff;
                    color: #929292;
                    outline: none;
                    &.previous {
                        margin-right: 20px;
                    }
                    &.next {
                        margin-left: 20px;
                    }
                }
                .annoucement-btn {
                    width: 8px;
                    height: 8px;
                    padding: 0;
                    margin-right: 6px;
                    background-color: #e5e5e5;
                    border: 0;
                    -webkit-border-radius: 4px;
                    -moz-border-radius: 4px;
                    border-radius: 4px;
                    outline: none;

                    &.selected {
                        background-color: #0088FF;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
            .btn-primary {
                display: block;
                margin: 0 auto;
            }
        }
    }

    @media screen and (max-width: 450px) {
        #announcements___BV_modal_body_ {
            padding: 0;
            .announcements-list {
                .announcements-list-header {
                    padding: 20px 14px 0;
                    .counter {
                        display: none;
                    }
                }
                h3 {
                    text-align: center;
                }
                .announcements-list-info {
                    padding: 0 14px 12px;
                    margin: 0;
                    text-align: center;
                    br {
                        display: none;
                    }
                }
                .annoucement {
                    position: relative;
                    display: flex;
                    flex-direction: column-reverse;
                    border: 0;
                    border-top: 1px solid #C9CFD4;
                    border-bottom: 1px solid #C9CFD4;
                    -webkit-border-radius: 0;
                    -moz-border-radius: 0;
                    border-radius: 0;
                    .counter-mobile {
                        position: absolute;
                        top: 14px;
                        right: 14px;
                        display: initial;
                    }
                    .left-side {
                        padding: 0 14px;
                    }
                    .right-side {
                        padding: 14px 0 0;
                        img {
                            height: 75px;
                            width: auto;
                            margin-bottom: 14px;
                        }
                    }
                }
                .slider-control {
                    margin: 20px 0;
                }
                .btn-primary {
                    margin-bottom: 20px;
                }
            }
            .single-announcement {
                padding: 14px;
                .announcement-img {
                    height: 75px;
                    width: auto;
                }
                .btn-primary {
                    margin-bottom: 20px;
                }
            }
        }
    }

    .dark-theme {
        #accept-terms___BV_modal_content_ {
            background-color: #3a4149;
            color: #ffffff;

            .terms-and-conditions-topbar {
                .logo-container {
                    .dark-version {
                        display: initial;
                    }
                    .light-version {
                        display: none;
                    }
                }
                i {
                    &:before {
                        color: #ffffff;
                    }
                }
            }
        }
        #announcements___BV_modal_body_ {
            .announcements-list {
                .annoucement {
                    border-color: #1a1c1d;
                }
            }
        }
    }

    .app {
        .app-footer {
            .left {
                a {
                    margin: 0 0 0 20px;
                }
            }
        }
    }
</style>
